<template>
  <div class="header">
    <Header></Header>
    <!-- banner -->
    <div class="bannerBox">
      <div class="container">
        <div class="storyTxt">
          <img height="120px" src="../../assets/picture/occupation/winner1.png">
        </div>
      </div>
    </div>
    <!-- section1 -->
    <div class="section1">
      <div class="container">
        <div class="title">
          2020佳期冬令营
        </div>
        <ul>
          <li class="part" v-for="(item,index) in liList" :key="index">
            <img height="100px" :src="item.picUrl">
            <div class="txt">
              <p>{{item.title}}</p>
              <p>{{item.name}}</p>
            </div>
            <div class="in">
              {{item.type}}
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- section3 -->
    <div class="section3">
      <div class="container">
        <img width="548px" class="mt137 mb30" src="../../assets/picture/occupation/winner2.png">
        <img width="548px" class="mb30" src="../../assets/picture/occupation/winner3.png">
      </div>
    </div>
   <!-- section2 -->
    <Code></Code>
    <!-- footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../common/header';
import Footer from '../common/footer';
import Code from '../common/code';
export default {
  data() {
    return {
      liIndex:-1,
      isShowSearch:false,
      liList:[
        {
          picUrl:require('../../assets/picture/occupation/t4.png'),
          title:'冬令营',
          name:'报名入口',
          type:'快速进入'
        },
        {
          picUrl:require('../../assets/picture/occupation/t5.png'),
          title:'关于冬令营的',
          name:'点点滴滴',
          type:'了解更多'
        }
      ],
    };
  },
  components: { Header,Footer,Code },
  methods: {
    showSearch(){
      this.isShowSearch = !this.isShowSearch;
    },
  }
};
</script>

<style lang="less" scoped>
.header{
  .bannerBox{    
    width: 100%;
    height: 620px;
    background: url(../../assets/picture/occupation/p16.png) no-repeat;
    background-size: cover;
    display: flex;
    .storyTxt{
        display: inline-block;
       img{
        margin-top: 238px;
       }
    }
  }
  /*********************************************/
  .section1{
    padding:120px 0;
    .title{      
      font-size: 30px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #900211;
      line-height: 42px;
      margin-bottom: 50px;
    }
    .part{
      width: 100%;
      height: 172px;
      background: #900211;
      margin-bottom: 30px;
      display: flex;
      position: relative;
      img{
        margin:36px 30px 36px 48px;
      }
      .txt{
        margin-top: 36px;       
        font-size: 30px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #F2F2F2;
        line-height: 42px;
      }
      .in{
        position: absolute;
        right: 78px;
        top:64px;
        width: 114px;
        height: 44px;
        border:1px solid #fff;
        padding-left: 26px;        
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #F2F2F2;
        line-height: 44px;
        cursor: pointer;
      }
    }
  }
  /*************************************************/
  .section3{
    width: 100%;
    height: 460px;
    background-image: url(../../assets/picture/occupation/weinner4.png);
    background-position: center center;
    background-size: cover;
    img{
      display: block;
      margin:0 auto;
    }
  }
 /****************************************************/
 .section2{ 
    height: 430px;
    background: #1C1C1C;
    .section2Box{
       display: flex;
      .destiption{
        height: 88px;
        border-right: 3px solid #CD2A20;
        margin:188px 0 154px 83px;        
        font-size: 26px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #FFFFFF;
        line-height: 40px;
        padding-right: 40px;
      }
      .destiption:last-of-type{
        padding-right: 0;
        border:none;
        margin-left: 40px;
      }
    }
    
 }
}
</style>
